import React from 'react'
import Progressbar from './progressbar'


const App = () => {
  return (
    <div>
      <Progressbar/>
    </div>
  )
}

export default App